import { createApp } from 'vue'
import App from './App.vue'
import VueGtag from 'vue-gtag';
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import setupInterceptors from './utils/api-interceptor'

setupInterceptors()
createApp(App).use(router).use(VueGtag, {config: { id: "G-2T89PJ80BN" }}).mount('#app')
